export const CREATE_SEGMENT_KEY = "audienceOverview.createSegmentFlow";
export const LIST_OPTIONS_KEY = "audienceOverview.createSegment.listOptions";

export const MAX_SEGMENT_CONDITIONS = 4;
export const DATE_VALUE_FORMAT = "YYYY-MM-DD";
export const DATE_DISPLAY_FORMAT = "MMM D, YYYY";

export type CreateSegmentStepKey = "rules" | "details" | "review";

export const CREATE_SEGMENT_STEPS: Array<{ key: CreateSegmentStepKey; titleKey: string }> = [
  { key: "rules", titleKey: `${CREATE_SEGMENT_KEY}.steps.rules` },
  { key: "details", titleKey: `${CREATE_SEGMENT_KEY}.steps.details` },
  { key: "review", titleKey: `${CREATE_SEGMENT_KEY}.steps.review` },
];

export const PREDICTED_LISTS = [
  { value: "High Spenders", key: "highSpenders" },
  { value: "Cart Abandoners", key: "cartAbandoners" },
  { value: "Loyal Customers", key: "loyalCustomers" },
  { value: "Likely to Churn", key: "likelyToChurn" },
  { value: "Subscribers", key: "subscribers" },
  { value: "Idle Customers", key: "idleCustomers" },
  { value: "Indecisive Customers", key: "indecisiveCustomers" },
] as const;

export type ConditionOperator = "and" | "or";
export type ConditionCategory = "list" | "location" | "orderActivity" | "signupDate";

export const CONDITION_CATEGORIES: ConditionCategory[] = [
  "list",
  "location",
  "orderActivity",
  "signupDate",
];

export const LIST_MEMBERSHIPS = ["in", "notIn"] as const;
export const LOCATION_FIELDS = ["city", "province"] as const;
export const LOCATION_OPERATORS = ["isOneOf", "isNotOneOf"] as const;
export const ORDER_ACTIONS = ["placedOrder", "notPlacedOrder"] as const;
export const ORDER_COMPARISONS = ["atLeast", "atMost", "exactly"] as const;
export const PERIOD_UNITS = ["days", "weeks", "months"] as const;
export const SIGNUP_OPERATORS = ["before", "after"] as const;

export type ListMembership = (typeof LIST_MEMBERSHIPS)[number];
export type LocationField = (typeof LOCATION_FIELDS)[number];
export type LocationOperator = (typeof LOCATION_OPERATORS)[number];
export type OrderAction = (typeof ORDER_ACTIONS)[number];
export type OrderComparison = (typeof ORDER_COMPARISONS)[number];
export type PeriodUnit = (typeof PERIOD_UNITS)[number];
export type SignupOperator = (typeof SIGNUP_OPERATORS)[number];

export interface EmptyCondition {
  id: number;
  category: null;
}

export interface ListCondition {
  id: number;
  category: "list";
  membership: ListMembership;
  listName: string | null;
}

export interface LocationCondition {
  id: number;
  category: "location";
  field: LocationField;
  operator: LocationOperator;
  values: string[];
}

export interface OrderActivityCondition {
  id: number;
  category: "orderActivity";
  action: OrderAction;
  comparison: OrderComparison;
  count: number | null;
  periodValue: number | null;
  periodUnit: PeriodUnit;
}

export interface SignupDateCondition {
  id: number;
  category: "signupDate";
  operator: SignupOperator;
  date: string | null;
}

export type FilledCondition =
  | ListCondition
  | LocationCondition
  | OrderActivityCondition
  | SignupDateCondition;

export type SegmentCondition = EmptyCondition | FilledCondition;

type WithoutId<T> = T extends unknown ? Omit<T, "id"> : never;
export type SegmentConditionDraft = WithoutId<FilledCondition>;

export interface SegmentRules {
  conditions: SegmentCondition[];
  operators: ConditionOperator[];
}

export interface SegmentPreview {
  people: number;
  email: number;
  whatsapp: number;
  /** Matching customers for each condition, in condition order. */
  steps: number[];
}
